export const SET_INITIALLY_FETCHED = 'SET_INITIALLY_FETCHED';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
